export const INDEX_REALTIME = 0;
export const INDEX_OEE = 1;
export const INDEX_CHECKS = 2;